<!-- <p>select-finish works!</p> -->
<!-- <p>choose-finish works!</p> -->

<div class="choose_finish_cont_outer">
	<h3>
		 <span class="finish_label">
			{{finishProfileData.displayName?finishProfileData.displayName:"Choose Finish"}}
		 </span>


		<ng-container *ngIf="selectedFinishedData.length>0">
			<span class="finish_name">
			{{selectedFinishedData[0].label | truncketHtml:30}}
			<ng-container *ngIf="(selectedFinishedData.length - 1)>0">
				and {{selectedFinishedData.length - 1}} finish<ng-container *ngIf="(selectedFinishedData.length - 1)>1">es</ng-container>  selected.
			</ng-container>
			</span>
		</ng-container>



	</h3>
	<div class="choose_finish_cont_with_more_option">
		<div class="choose_finish_cont_inner">
			<ng-container *ngFor="let item of finishProfileList; let i  = index">

				<ng-container *ngIf="i<5">

				<button (click)="selectFinishOption(i)"
				(mouseenter)="moreFabricnfo(i)"
				(mouseleave)="moreFinishRemove($event)"
				class="{{item.checked?'active':''}} {{deltaIndexForMoreInfo == i?'popup_active':''}} choose_outer_fabric {{item.checked}}">
					<img src="{{item.image}}" alt="{{item.label}}" />

					<div class="morefabric_inner {{deltaIndex==(i+1)?'show':''}}">

						<span class="close" (click)="moreFinishRemove($event)">
							<span class="material-symbols-outlined">
								close
							</span>
						</span>

						<fb-choose-more-fabric-finish-outer [name]="item.label"
							[price]="item.price+''" [currency]="''" [image]="item.image" [unit]="''"
							[overview]="item.description">
						</fb-choose-more-fabric-finish-outer>
					</div>
				</button>

			</ng-container>

			</ng-container>
			<div class="more_option_button  not_button_like  image_button {{isMoreSelected?'active':''}}" (click)="showFinishMoreOption()" (mouseenter)="moreFabricnfo(-5)" (mouseleave)="moreFinishRemove($event)"
				*ngIf="finishProfileListMoreThan4.length>4">
				<!-- <span>More Option</span>
				<span class="material-symbols-outlined">
					chevron_right
				</span> -->
				<img src="https://dummyimage.com/200x200/fff/fff">
				<span>+{{finishProfileListMoreThan4.length}}</span>
			</div>
		</div>


	</div>
	<fb-select-more-finish *ngIf="closeFinishOption" (closeFInish)="closeFinishedClicked()" (continiueFinishClicked)="continueFinishedClicked($event)"
		[finishProfileMorethan4Image]="finishProfileListMoreThan4">

	</fb-select-more-finish>

</div>
